import { gql } from 'graphql-request'

export const sitePaymentGatewayOnboardingStatusQuery = gql`
  query SitePaymentGatewayOnboardingStatus($siteId: ID!) {
    site(siteId: $siteId) {
      paymentGatewayOnboardingStatus {
        onboardingStatus
        requiresAttention
        hasEventuallyDueRequirements
      }
    }
  }
`
